import { CustomTableHeaderProps } from '@components/custom-table/types';

export const SOURCES_PAGE_LIMIT = 10;

export const SOURCE_INSIGHT_CARD_COPY = {
  topVolume: {
    title: 'Top Volume',
    metricSuffix: 'Leads'
  },
  highestConversion: {
    title: 'Highest Conversion',
    metricSuffix: 'Conversion Rate'
  },
  highestRevenue: {
    title: 'Highest Revenue'
  },
  emptyMessage: 'No data to show !'
} as const;

const DISTRIBUTION_COPY_SHARED = {
  viewAdSources: 'View Ad Sources',
  errorTitle: 'Something went wrong',
  errorDescription: 'Please try again later.'
} as const;

const DISTRIBUTION_COPY_BY_VARIANT = {
  source: {
    title: 'Distribution by source',
    emptyTitle: 'No lead sources found',
    emptyDescription:
      'Lead sources will appear here as you begin managing leads.',
    nameColumn: { Header: 'Source', accessor: 'source' }
  },
  ad: {
    title: 'Distribution by ad',
    emptyTitle: 'No ad sources found',
    emptyDescription:
      'Ad sources will appear here as you begin managing leads.',
    nameColumn: { Header: 'Ad name', accessor: 'ad' }
  }
} as const;

export const getSourceDistributionCopy = (isAdSource: boolean) => ({
  ...DISTRIBUTION_COPY_SHARED,
  ...DISTRIBUTION_COPY_BY_VARIANT[isAdSource ? 'ad' : 'source']
});

/** Exact normalized source name → Icon `name` (see `src/components/icon/icons`). */
export const SOURCE_ICON_BY_NAME: Record<string, string> = {
  facebook_ads: 'facebook-source-logo',
  facebook_dm: 'facebook-source-logo',
  facebook_dms: 'facebook-source-logo',
  whatsapp: 'whatsapp-source-logo',
  website: 'website-source-logo',
  instagram_dm: 'instagram-source-logo',
  instagram_dms: 'instagram-source-logo',
  referral: 'referral-source-logo'
};

/** Initials avatar palette — assigned deterministically from the source name. */
export const SOURCE_AVATAR_COLORS = [
  { bg: 'bg-cofeeOrange50', text: 'text-cofeeOrange400' },
  { bg: 'bg-cofeeGreen11', text: 'text-cofeeGreen7' },
  { bg: 'bg-cofeeViolet50', text: 'text-cofeeViolet300' },
  { bg: 'bg-cofeeBlue50', text: 'text-cofeeBlue600' }
] as const;

export const getSourceDistributionTableColumns = (
  isAdSource: boolean
): CustomTableHeaderProps[] => {
  const { nameColumn } = getSourceDistributionCopy(isAdSource);

  return [
    { ...nameColumn, width: '28%' },
    {
      Header: 'Leads',
      accessor: 'leads',
      width: '16%',
      sortable: true,
      sortKey: 'leads'
    },
    {
      Header: 'Converted',
      accessor: 'converted',
      width: '16%',
      sortable: true,
      sortKey: 'converted'
    },
    {
      Header: 'Conv.rate',
      accessor: 'conversionRate',
      width: '18%',
      sortable: true,
      sortKey: 'conversion_rate'
    },
    {
      Header: 'Revenue',
      accessor: 'revenue',
      width: '22%',
      sortable: true,
      sortKey: 'revenue'
    }
  ];
};
